import { Input } from '@builder.io/sdk';

import imageField from 'molecules/Image/config';

export const rtcCardColorField = {
  name: 'color',
  type: 'string',
  enum: [{ label: 'Green', value: 'green' }],
  defaultValue: 'green',
  helperText: 'Accent or background color style applied to the card.',
} as const satisfies DeepReadonly<Input>;

export const authorFields = [
  {
    name: 'name',
    type: 'string',
    defaultValue: 'Chris Rallis',
    required: true,
    helperText: 'Full name of the author.',
  },
  imageField('headshot'),
  {
    name: 'title',
    type: 'string',
    defaultValue: 'Head of Customer Experience',
    helperText: 'Author’s role or job title.',
  },
] as const satisfies DeepReadonly<Input[]>;

export type AuthorConfigProps = GenerateBuilder<typeof authorFields>;
